// Sistema di foto fake realistiche usando Unsplash

export const FAKE_PROFILE_PHOTOS = [
  'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=400&h=400&fit=crop', // Woman 1
  'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=400&fit=crop', // Man 1
  'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=400&h=400&fit=crop', // Woman 2
  'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400&h=400&fit=crop', // Man 2
  'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=400&h=400&fit=crop', // Woman 3
  'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=400&h=400&fit=crop', // Man 3
  'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=400&h=400&fit=crop', // Woman 4
  'https://images.unsplash.com/photo-1531427186611-ecfd6d936c79?w=400&h=400&fit=crop', // Man 4
];

export const FAKE_PROPERTY_PHOTOS = {
  hotels: [
    'https://images.unsplash.com/photo-1566073771259-6a8506099945?w=800',
    'https://images.unsplash.com/photo-1542314831-068cd1dbfeeb?w=800',
    'https://images.unsplash.com/photo-1551882547-ff40c63fe5fa?w=800',
    'https://images.unsplash.com/photo-1582719478250-c89cae4dc85b?w=800',
    'https://images.unsplash.com/photo-1520250497591-112f2f40a3f4?w=800',
  ],
  rooms: [
    'https://images.unsplash.com/photo-1618773928121-c32242e63f39?w=800',
    'https://images.unsplash.com/photo-1611892440504-42a792e24d32?w=800',
    'https://images.unsplash.com/photo-1590490360182-c33d57733427?w=800',
    'https://images.unsplash.com/photo-1582719508461-905c673771fd?w=800',
    'https://images.unsplash.com/photo-1505693416388-ac5ce068fe85?w=800',
  ],
  views: [
    'https://images.unsplash.com/photo-1540541338287-41700207dee6?w=800',
    'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=800',
    'https://images.unsplash.com/photo-1559827260-dc66d52bef19?w=800',
    'https://images.unsplash.com/photo-1499092346589-b9b6be3e94b2?w=800',
  ],
  amenities: [
    'https://images.unsplash.com/photo-1575429198097-0414ec08e8cd?w=800', // Pool
    'https://images.unsplash.com/photo-1540555700478-4be289fbecef?w=800', // Spa
    'https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=800', // Restaurant
  ]
};

export const FAKE_DESTINATIONS = [
  {
    city: 'Amalfi',
    image: 'https://images.unsplash.com/photo-1558089687-79200169a8bf?w=800',
    description: 'Costa Amalfitana'
  },
  {
    city: 'Positano',
    image: 'https://images.unsplash.com/photo-1544571502-37b2d1dbe48e?w=800',
    description: 'Perla della Costiera'
  },
  {
    city: 'Capri',
    image: 'https://images.unsplash.com/photo-1555074725-7f0b2b45f451?w=800',
    description: 'Isola del Glamour'
  },
  {
    city: 'Sorrento',
    image: 'https://images.unsplash.com/photo-1519452575417-564c1401ecc0?w=800',
    description: 'Terra delle Sirene'
  }
];

// Genera profilo fake per viaggiatore
export const generateFakeTravelerProfile = (index = 0) => {
  const names = [
    { nome: 'Lucia', cognome: 'Ferrari', bio: 'Amante del mare e della cultura' },
    { nome: 'Marco', cognome: 'Bianchi', bio: 'Digital nomad in cerca di avventure' },
    { nome: 'Sofia', cognome: 'Russo', bio: 'Travel blogger e fotografa' },
    { nome: 'Alessandro', cognome: 'Romano', bio: 'Executive frequente' },
    { nome: 'Giulia', cognome: 'Ricci', bio: 'Wellness enthusiast' },
    { nome: 'Matteo', cognome: 'Colombo', bio: 'Food & wine lover' },
    { nome: 'Chiara', cognome: 'Esposito', bio: 'Architetta in vacanza' },
    { nome: 'Francesco', cognome: 'Bruno', bio: 'Sportivo e nature lover' },
  ];

  const profile = names[index % names.length];
  
  return {
    ...profile,
    photo: FAKE_PROFILE_PHOTOS[index % FAKE_PROFILE_PHOTOS.length],
    verified: true,
    trips_count: Math.floor(Math.random() * 20) + 5,
    reviews_count: Math.floor(Math.random() * 15) + 2,
    rating: (4 + Math.random()).toFixed(1)
  };
};

// Genera property fake
export const generateFakeProperty = (index = 0) => {
  const properties = [
    {
      name: 'Hotel Bella Vista',
      type: 'Hotel 4★',
      description: 'Hotel di charme con vista mozzafiato sul mare di Amalfi',
      city: 'Amalfi',
      address: 'Via Matteo Camera, 4',
      amenities: ['Piscina', 'Spa', 'Ristorante', 'Wi-Fi', 'Parcheggio'],
      rating: 4.8,
      reviews: 156
    },
    {
      name: 'Villa Tramonto',
      type: 'Villa di Lusso',
      description: 'Villa esclusiva con giardino mediterraneo e vista panoramica',
      city: 'Positano',
      address: 'Via Pasitea, 123',
      amenities: ['Jacuzzi', 'Giardino', 'BBQ', 'Wi-Fi', 'Chef privato'],
      rating: 4.9,
      reviews: 89
    },
    {
      name: 'B&B Mare Nostrum',
      type: 'Bed & Breakfast',
      description: 'Accogliente B&B familiare a due passi dal mare',
      city: 'Sorrento',
      address: 'Corso Italia, 45',
      amenities: ['Colazione inclusa', 'Wi-Fi', 'Terrazza', 'AC'],
      rating: 4.6,
      reviews: 203
    },
    {
      name: 'Resort Paradiso',
      type: 'Resort 5★',
      description: 'Resort di lusso con spiaggia privata e servizi esclusivi',
      city: 'Capri',
      address: 'Via Marina Grande, 8',
      amenities: ['Spiaggia privata', 'Spa', '3 Ristoranti', 'Piscina', 'Navetta'],
      rating: 4.9,
      reviews: 312
    }
  ];

  const property = properties[index % properties.length];
  
  return {
    ...property,
    photos: [
      FAKE_PROPERTY_PHOTOS.hotels[index % FAKE_PROPERTY_PHOTOS.hotels.length],
      ...FAKE_PROPERTY_PHOTOS.rooms.slice(0, 3),
      FAKE_PROPERTY_PHOTOS.views[index % FAKE_PROPERTY_PHOTOS.views.length]
    ],
    owner_photo: FAKE_PROFILE_PHOTOS[(index + 1) % FAKE_PROFILE_PHOTOS.length],
    owner_name: index % 2 === 0 ? 'Marco Bianchi' : 'Laura Conti',
    verified: true,
    response_rate: 95 + Math.floor(Math.random() * 5),
    response_time: '< 1 ora'
  };
};

export const getRandomPhoto = (type = 'hotel') => {
  const photos = {
    hotel: FAKE_PROPERTY_PHOTOS.hotels,
    room: FAKE_PROPERTY_PHOTOS.rooms,
    view: FAKE_PROPERTY_PHOTOS.views,
    profile: FAKE_PROFILE_PHOTOS
  };
  
  const array = photos[type] || photos.hotel;
  return array[Math.floor(Math.random() * array.length)];
};
